
import { defineComponent } from 'vue';

import { useStore } from 'vuex';
import { Actions } from '@/store';

import ModalHeader from '@/modules/modals/components/ModalHeader.vue';
import ModalFooter from '@/modules/modals/components/ModalFooter.vue';
import ModalBody from '@/modules/modals/components/ModalBody.vue';
import ModalService from '@/modules/modals/services/modalService';
import { LocalStorageKeys } from '@/constants/LocalStorageKeys';
import theLocalStorageUtils from '@/utils/LocalStorageUtils';
import HostUtils from '@/utils/HostUtils';

export default defineComponent({
    components: { ModalHeader, ModalBody, ModalFooter },
    props: ['comps'],
    data(props) {
        return {
            modal: null,
            compsList: props.comps,
            dontShowAgain: false
        };
    },
    setup() {
        const store = useStore();
        return {
            store
        };
    },
    mounted() {
        const modalElement = this.$refs.unVisitedComps;
        this.modal = ModalService.initialize(modalElement, this);
        ModalService.size(modalElement, '');
        ModalService.open(this.modal);
    },
    methods: {
        async saveModalState() {
            theLocalStorageUtils.save(LocalStorageKeys.showModalAnnouncements, this.dontShowAgain ? 'false' : 'true');
            ModalService.hide(this.modal);
        },
        getLink(): string {
            let result = `https://help.alamode.com/kb/guide/en/CFWJa1CFDY/Steps/6067854`;
            if (HostUtils.isTotal()) {
                result = `https://help.alamode.com/kb/guide/en/CFWJa1CFDY/Steps/6067854/?popout=1`;
            }
            return result;
        },
        getTarget(): string {
            let result = `_blank`;
            if (HostUtils.isTotal()) {
                result = ``;
            }
            return result;
        },
    }
});
